/* ============================================================
   OTTR — back to top.

   The header scrolls away on every page, so from halfway down a
   long one there is no way back to the navigation except a long
   drag. One button, bottom right, after the reader has gone more
   than a screen and a bit.

   IT SCROLLS .page-wrapper, NOT THE WINDOW. In this theme <body>
   is a flex column with overflow:hidden and .page-wrapper does
   the scrolling, so window.scrollY is always 0 and
   window.scrollTo does nothing. Same trap as the manual's
   segment strip.

   It also steps up over Shopify's preview bar, which only exists
   while an unpublished theme is being previewed. The bar is an
   iframe called PBarNextFrame — not the #preview-bar-iframe the
   older docs name.
   ============================================================ */
(function(){
  if (document.querySelector('.totop')) return;

  var scroller = document.querySelector('.page-wrapper') || document.scrollingElement;
  var onWindow = scroller === document.scrollingElement;

  var btn = document.createElement('button');
  btn.className = 'totop';
  btn.type = 'button';
  btn.setAttribute('aria-label', 'Back to top');
  btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M12 19V6"/><path d="M5.5 12.5 12 6l6.5 6.5"/></svg>';
  document.body.appendChild(btn);

  var shown = false;
  var queued = false;

  function read(){
    return onWindow ? (window.scrollY || document.documentElement.scrollTop) : scroller.scrollTop;
  }

  function check(){
    queued = false;
    var want = read() > window.innerHeight * 1.2;
    if (want === shown) return;
    shown = want;
    btn.classList.toggle('on', want);
  }

  (onWindow ? window : scroller).addEventListener('scroll', function(){
    if (queued) return;
    queued = true;
    requestAnimationFrame(check);
  }, {passive: true});

  btn.addEventListener('click', function(){
    var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (onWindow) window.scrollTo({top: 0, behavior: smooth ? 'smooth' : 'auto'});
    else scroller.scrollTo({top: 0, behavior: smooth ? 'smooth' : 'auto'});
  });

  function previewBar(){
    var bar = document.getElementById('PBarNextFrame') ||
              document.getElementById('preview-bar-iframe');
    document.body.classList.toggle('has-previewbar', !!bar);
  }
  previewBar();
  setTimeout(previewBar, 1500);

  check();
})();
